import { render, staticRenderFns } from "./SGPTabComponent.vue?vue&type=template&id=214f78d3"
import script from "./SGPTabComponent.vue?vue&type=script&lang=js"
export * from "./SGPTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports